import dynamic from 'next/dynamic';

export const Button = ({ style= null, ...props }) => {
  const Link = dynamic(() => import('next/link'));

  let styles = 'relative inline-flex items-center flex justify-center rounded-md font-semibold focus:outline-none focus:ring-2 focus:ring-offset-2 transition-all';

  //Sizing styles
  if(props.small){
    styles = styles + ' px-4 py-2 text-sm md:text-base'
  } else if(props.xsmall){
    styles = styles + ' px-4 py-2 text-sm md:text-xs'
  } else if(props.medium){
    styles = styles + ' px-6 py-3 text-sm md:text-lg'
  } else if(props.xlarge){
    styles = styles + ' px-8 py-4 text-sm md:text-2xl'
  } else {
    styles = styles + ' px-8 py-3 text-sm md:text-xl'
  }

  //Color styles
  if(props.secondary){
    styles = styles + ' text-white bg-secondary hover:bg-secondary-2'
  } else if(props.gray){
    styles = styles + ' text-blue-500 bg-white hover:scale-105 transition-transform'
  } else if(props.white){
    styles = styles + ' bg-white hover:bg-gray-100'
  } else if(props.red){
    styles = styles + ' text-white bg-red-500 hover:bg-red-600'
  } else if (props.blue) {
    styles = styles + ' bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-xl hover:scale-105 transition-transform'
  } else if (props.green) {
    styles = styles + ' bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-xl hover:scale-105 transition-transform'
  } else if (props.white_on_blue) {
    styles = styles + ' bg-white hover:bg-purple-700 text-white px-8 py-4 rounded-xl hover:scale-105 transition-transform'
  } else {
    styles = styles + ' bg-primary hover:bg-primary-2'
  }

  if(props.mobileFull){
    styles = styles + ' w-full sm:w-auto x'
  }

  if(props.href){
    return(
        <Link
            legacyBehavior
            passHref
            href={props.href}
            onClick={props.external ? () => {} : props.onClick}
            target={props.external ? '_blank' : ''}
        >
          <a
              className={`${styles} ${props.className || ''}`}
              style={style}
          >
            {props.children}
          </a>
        </Link>
    )
  } else {
    return(
      <button 
        disabled={props.disabled && props.disabled}
        onClick={props.onClick && props.onClick}
        className={`${styles} ${props.className ? props.className : ''}`}
        style={style}
      >
        {props.children && props.children}
      </button>
    )
  }
};

export default Button;